var _a;
import { __assign } from "tslib";
import { useReducer, useContext, useMemo } from 'react';
import { createAction, handleActions } from 'redux-actions';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { useDeepEqualMemo } from '@wix/da-hooks/pkg/useDeepEqualMemo';
var onMouseEnter = createAction('mouseenter', function (isMobile) { return ({
    isMobile: isMobile,
}); });
var onMouseLeave = createAction('mouseleave', function () { return ({}); });
var onReferenceClick = createAction('refclick', function (hasPopover) { return ({
    hasPopover: hasPopover,
}); });
var onClose = createAction('hide', function () { return ({}); });
var reducer = handleActions((_a = {},
    _a[onMouseEnter.toString()] = function (state, _a) {
        var isMobile = _a.payload.isMobile;
        return (state.showTooltip || isMobile ? state : { showTooltip: 'tooltip' });
    },
    _a[onMouseLeave.toString()] = function (state) {
        return state.showTooltip === 'tooltip' ? { showTooltip: false } : state;
    },
    _a[onReferenceClick.toString()] = function (state, _a) {
        var hasPopover = _a.payload.hasPopover;
        if (!hasPopover || state.showTooltip === 'popover') {
            return { showTooltip: false };
        }
        return { showTooltip: 'popover' };
    },
    _a[onClose.toString()] = function (state) {
        return state.showTooltip
            ? __assign(__assign({}, state), { showTooltip: false }) : state;
    },
    _a), { showTooltip: false });
export function usePopoverOrTooltip(hasPopover, hasTooltip, openBiData, closeBiData) {
    var isMobile = useContext(MobileContext);
    var _a = useReducer(reducer, {
        showTooltip: false,
    }), state = _a[0], dispatch = _a[1];
    var logBiEvent = useBiLogger();
    var biData = useDeepEqualMemo((state === null || state === void 0 ? void 0 : state.showTooltip) === 'popover' ? closeBiData : openBiData);
    return useMemo(function () { return ({
        showTooltip: (state && state.showTooltip) || false,
        onMouseEnter: hasTooltip
            ? function () { return dispatch(onMouseEnter(isMobile)); }
            : undefined,
        onMouseLeave: hasTooltip ? function () { return dispatch(onMouseLeave()); } : undefined,
        onReferenceClick: function () {
            biData && logBiEvent(biData);
            dispatch(onReferenceClick(hasPopover));
        },
        onClose: function () { return dispatch(onClose()); },
    }); }, [biData, hasPopover, hasTooltip, isMobile, logBiEvent, state]);
}
//# sourceMappingURL=usePopoverOrTooltip.js.map